import { Pipe, PipeTransform } from '@angular/core';
import {Article} from "./../article/article";

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(articles:Article[], searchString:string):Article[] {
    if (!articles) return null;

    // search for the search string in title and isbn of the article
    return articles.filter(article => {
      return (article.title.toLowerCase().indexOf(searchString.toLowerCase()) != -1)
        || (article.isbn.indexOf(searchString) != -1);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/filter/search-filter.pipe.ts